// Styled-components wrappers for app pages
import styled from 'styled-components';
import { Card } from 'antd';
import { Link as RouterLink } from 'react-router-dom';

export const Spinner = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-end;
    width: 100%;
    max-width: 600px;
    gap: ${({ theme }) => theme.spacing.md};

    @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
        justify-content: center;
    }
`;

export const BreadcrumbWrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    margin-top: 16px;
    width: 100vw;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    padding: 0 ${({ theme }) => theme.spacing.lg};
    overflow-x: auto;
    overflow-y: hidden;

    @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
        overflow-x: visible;
        overflow-y: visible;
    }

    .ant-breadcrumb {
        width: 100%;
        max-width: 100%;
        display: flex;
        flex-wrap: nowrap;
        min-width: fit-content;

        @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
            flex-wrap: wrap;
            min-width: auto;
            justify-content: center;
        }
    }

    .ant-breadcrumb ol {
        display: flex;
        flex-wrap: nowrap;
        width: 100%;
        justify-content: center;
        min-width: fit-content;

        @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
            flex-wrap: wrap;
            min-width: auto;
            justify-content: center;
        }
    }

    .ant-breadcrumb li {
        flex-shrink: 0;
        white-space: nowrap;

        @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
            flex-shrink: 1;
        }
    }

    .ant-breadcrumb-link {
        color: var(--ant-breadcrumb-link-color, ${({ theme }) => theme.colors.text.secondary}) !important;
        white-space: nowrap;
    }

    .ant-breadcrumb-separator {
        color: var(--ant-breadcrumb-separator-color, ${({ theme }) => theme.colors.text.secondary}) !important;
        flex-shrink: 0;
        margin: 0 8px;
    }
`;

export const LinkWrapper = styled.div`
    text-align: center;
    margin-top: 16px;
`;

export const StyledLink = styled(RouterLink)`
    color: ${({ theme }) => {
        // Check if dark mode by background color
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? 'rgba(135, 206, 250, 0.85)' : theme.colors.text.link;
    }};
    text-decoration: none;
    transition: color 0.2s;
    
    &:hover {
        color: ${({ theme }) => {
        // Check if dark mode by background color
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? 'rgba(173, 216, 230, 1)' : theme.colors.linkHover;
    }};
    }
`;

export const MessageText = styled.p`
    margin: 0;
`;

export const AuthCard = styled(Card)`
    width: 100%;
    max-width: 420px;
    background: transparent;
    border: none;
    box-shadow: none;
    
    .ant-card-head {
        background: transparent;
        border-bottom: none;
        padding: 0;
        height: auto;
        min-height: 0;
    }

    .ant-card-head-title {
        /* Allow wrapping (prevents cropping on very small widths) */
        white-space: normal;
        overflow: visible;
        text-overflow: unset;
        padding: 0;
        margin: 0;
        text-align: center;
        display: block;
        width: 100%;
        max-width: 100%;
        font-size: clamp(20px, 3.2vw, 36px);
        font-weight: 700;
        line-height: 1.25;
        letter-spacing: -0.03em;
        color: var(--ant-color-text-heading);
        text-wrap: balance;

        /* Keep it in one line when there is enough room */
        @media (min-width: 376px) {
            white-space: nowrap;
        }
    }

    .ant-card-body {
        padding: ${({ theme }) => theme.spacing.xl};
        display: flex;
        flex-direction: column;
        gap: ${({ theme }) => theme.spacing.lg};
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
        max-width: 100%;
    }
`;

export const PreloadOverlayWrapper = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${({ theme }) => theme.spacing.lg};
    z-index: ${({ theme }) => theme.zIndex.modal + 99};
`;

export const PreloadOverlayCard = styled.div`
    width: 100%;
    max-width: 520px;
    background: ${({ theme }) => theme.colors.background.default};
    border-radius: ${({ theme }) => theme.borderRadius.lg};
    padding: ${({ theme }) => theme.spacing.xl};
    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.35);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.md};
    text-align: center;
`;

export const PreloadOverlayActions = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${({ theme }) => theme.spacing.md};
    flex-wrap: wrap;
`;

export const MobileLogoImage = styled.img`
    display: none;

    @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
        display: block;
        width: 250px;
        margin: 25px auto 0 auto;
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
        width: 200px;
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
        width: 150px;
    }
`;

export const BannerPanel = styled.div`
    width: 100%;
    height: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0;
    padding: ${({ theme }) => theme.spacing.xl};
    background: #F04A4A;
    border-radius: 0 25px 25px 0;

    @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
        display: none;
    }
`;

export const LogoImage = styled.img`
    width: 200px;
    height: auto;
    object-fit: contain;

    @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
        width: 180px;
    }
`;

export const BannerImage = styled.img`
    width: 100%;
    max-width: 400px;
    height: auto;
    object-fit: contain;
    display: block;

    @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
        max-width: 340px;
    }
`;

export const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

export const BannerHeadline = styled.h1`
    font-family: var(--font-family-lufga);
    font-weight: var(--font-weight-lufga-bold);
    font-size: 2.2rem;
    color: #ffffff;
    text-align: center;
    margin: 20px 0 0 0;
`;

export const BannerSubheadline = styled.p`
    font-family: var(--font-family-lufga);
    font-weight: var(--font-weight-lufga-regular);
    font-size: 1rem;
    color: rgba(255, 255, 255, 0.85);
    text-align: center;
    margin: -5px 0 0 0;
    max-width: 360px;
`;

export const FormWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    order: 2;
    width: 100%;

    @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
        width: 100%;
        height: 100%;
        min-height: 100vh;
        max-height: 100vh;
        max-height: 100dvh;
        overflow-y: auto;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2;
        backdrop-filter: blur(12px);
        -webkit-backdrop-filter: blur(12px);
        padding: ${({ theme }) => theme.spacing.xl};
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
        padding: ${({ theme }) => theme.spacing.lg};
    }
`;

export const FormInner = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    max-width: 320px;

    .ant-card {
        width: 100%;
        max-width: 420px;
        background: transparent;
        border: none;
        box-shadow: none;
        padding: 0;
        margin: 0 auto;
    }

    .ant-card-head {
        border-bottom: none;
        padding: 0;
        margin-bottom: ${({ theme }) => theme.spacing.md};
        text-align: center;
        background: transparent;
    }

    .ant-card-head-title {
        font-size: 2.25rem;
        font-weight: 700;
        line-height: 1.5;
        letter-spacing: -0.02em;
        /* Color uses Ant Design CSS variable that adapts to theme mode */
        color: var(--ant-color-text-heading);
    }

    .ant-card-body {
        padding: ${({ theme }) => theme.spacing.xl} 0 0;
        display: flex;
        flex-direction: column;
        align-items: stretch;
    }

    .auth-form-helper {
        text-align: right;
        margin: 0;
    }
`;

export const NoAccountLink = styled.p`
    text-align: center;
    margin-top: 16px;
    width: 100%;
`;

export const ErrorPageContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 90vh;
    width: 100%;
    padding: ${({ theme }) => theme.spacing.xl};
    text-align: center;
`;

export const ErrorIllustration = styled.div`
    margin-bottom: ${({ theme }) => theme.spacing.xl};
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const ErrorCode = styled.h1`
    font-family: var(--font-family-lufga);
    font-weight: var(--font-weight-lufga-bold);
    font-size: 6rem;
    color: #F04A4A;
    margin: 0 0 ${({ theme }) => theme.spacing.md} 0;
    line-height: 1.2;

    @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
        font-size: 3rem;
    }
`;

export const ErrorMessage = styled.p`
    font-family: var(--font-family-figtree);
    font-weight: var(--font-weight-figtree-regular);
    font-size: 1.1rem;
    color: ${({ theme }) => theme.colors.text.secondary};
    margin: 0 0 ${({ theme }) => theme.spacing.xl} 0;
    max-width: 500px;

    @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
        font-size: 1rem;
    }
`;

export const ErrorActionButton = styled.div`
    margin-top: ${({ theme }) => theme.spacing.lg};
`;

/** Confirm identity — agent strip (Dispatchly red / neutral glass) */
const AGENT_ROW_H = '36px';

export const AgentAssistBar = styled.div`
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 8px 10px;
    width: 100%;
    min-width: 0;
    min-height: calc(${AGENT_ROW_H} + 20px);
    padding: 10px 12px;
    border-radius: 12px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
    border: 1px solid
        ${({ theme }) => {
            const isDark = theme.colors.background.default === '#141414';
            return isDark ? 'rgba(240, 74, 74, 0.35)' : 'rgba(240, 74, 74, 0.28)';
        }};
    background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? 'rgba(255, 255, 255, 0.06)' : 'rgba(240, 74, 74, 0.06)';
    }};
    margin-bottom: 4px;
`;

/** Avatar + name as one aligned unit */
export const AgentAssistIdentity = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    flex: 0 1 auto;
    max-width: min(280px, 58vw);
    height: ${AGENT_ROW_H};
`;

export const AgentAssistAvatar = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: ${AGENT_ROW_H};
    height: ${AGENT_ROW_H};
    border-radius: 50%;
    background: rgba(240, 74, 74, 0.2);
    color: #f04a4a;
    flex-shrink: 0;

    .anticon {
        font-size: 16px;
        line-height: 1;
        display: flex;
    }
`;

export const AgentAssistName = styled.span`
    font-family: var(--font-family-lufga);
    font-weight: 600;
    font-size: 14px;
    line-height: 1.25;
    color: var(--ant-color-text-heading);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    height: 100%;
`;

export const AgentAssistDivider = styled.span`
    width: 1px;
    height: ${AGENT_ROW_H};
    align-self: center;
    background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? 'rgba(255, 255, 255, 0.14)' : 'rgba(0, 0, 0, 0.1)';
    }};
    flex-shrink: 0;
`;

export const AgentAssistLink = styled.a`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    box-sizing: border-box;
    height: ${AGENT_ROW_H};
    min-height: ${AGENT_ROW_H};
    padding: 0 12px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
    flex-shrink: 0;
    line-height: 1;

    .anticon {
        font-size: 14px;
        line-height: 1;
        display: flex;
    }
    color: var(--ant-color-text-heading);
    text-decoration: none;
    border: 1px solid
        ${({ theme }) => {
            const isDark = theme.colors.background.default === '#141414';
            return isDark ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.12)';
        }};
    transition: background 0.2s ease, border-color 0.2s ease;

    &:hover {
        background: rgba(240, 74, 74, 0.12);
        border-color: rgba(240, 74, 74, 0.45);
        color: var(--ant-color-text-heading);
    }
`;

/** Same chrome as AgentAssistLink when call/email is not configured */
export const AgentAssistMuted = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    box-sizing: border-box;
    height: ${AGENT_ROW_H};
    min-height: ${AGENT_ROW_H};
    padding: 0 12px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
    flex-shrink: 0;
    line-height: 1;

    .anticon {
        font-size: 14px;
        line-height: 1;
        display: flex;
    }
    color: var(--ant-color-text-secondary);
    border: 1px dashed
        ${({ theme }) => {
            const isDark = theme.colors.background.default === '#141414';
            return isDark ? 'rgba(255, 255, 255, 0.18)' : 'rgba(0, 0, 0, 0.12)';
        }};
    opacity: 0.72;
    cursor: not-allowed;
    user-select: none;
`;

export const IdentityHint = styled.p`
    margin: 0 0 8px 0;
    font-size: 13px;
    line-height: 1.5;
    color: var(--ant-color-text-secondary);
    text-align: center;
`;

/**
 * Verified eDoc experience (post identity verification)
 * Layout inspired by "Book My Shipment" UX but themed for Dispatchly.
 */
export const EdocVerifiedViewport = styled.div`
    position: fixed;
    inset: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0; /* content handles its own padding */
    background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#141414' : '#F5F7FB';
    }};

    /* Theme-aware scrollbar (WebKit + Firefox) */
    scrollbar-width: thin;
    scrollbar-color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark
            ? 'rgba(255, 255, 255, 0.28) rgba(255, 255, 255, 0.06)'
            : 'rgba(0, 0, 0, 0.28) rgba(0, 0, 0, 0.06)';
    }};

    &::-webkit-scrollbar {
        width: 10px;
    }
    &::-webkit-scrollbar-track {
        background: ${({ theme }) => {
            const isDark = theme.colors.background.default === '#141414';
            return isDark ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.06)';
        }};
    }
    &::-webkit-scrollbar-thumb {
        background: ${({ theme }) => {
            const isDark = theme.colors.background.default === '#141414';
            return isDark ? 'rgba(255, 255, 255, 0.28)' : 'rgba(0, 0, 0, 0.28)';
        }};
        border-radius: 999px;
        border: 2px solid transparent;
        background-clip: content-box;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: ${({ theme }) => {
            const isDark = theme.colors.background.default === '#141414';
            return isDark ? 'rgba(255, 255, 255, 0.38)' : 'rgba(0, 0, 0, 0.38)';
        }};
        background-clip: content-box;
    }
`;

export const EdocVerifiedShell = styled.div`
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    padding: 32px 24px;
    min-height: 100vh;
    color: var(--ant-color-text);

    position: relative;
    display: flex;
    flex-direction: column;
    gap: 14px;

    @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
        padding: 20px 14px;
    }
`;

export const EdocVerifiedCard = styled(Card)`
    border-radius: 16px;
    border: 1px solid ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.08)';
    }};
    background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? 'rgba(255,255,255,0.04)' : '#ffffff';
    }};
    box-shadow: 0 18px 60px rgba(15, 23, 42, 0.10);
    color: var(--ant-color-text);
    flex: 0 0 auto;

    .ant-card-body {
        padding: 22px;
        display: flex;
        flex-direction: column;
        gap: 18px;
    }
`;


export const EdocTopRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    flex-wrap: wrap;
    flex: 0 0 auto;
`;

export const EdocStepsWrap = styled.div`
    .ant-steps {
        width: 100%;
    }
    .ant-steps-item-title {
        font-weight: 600;
        color: var(--ant-color-text-heading) !important;
    }
    .ant-steps-item-description {
        color: var(--ant-color-text-secondary) !important;
    }
    .ant-steps-item-icon {
        border-color: rgba(240, 74, 74, 0.55) !important;
    }
    .ant-steps-item-process .ant-steps-item-icon {
        background: #F04A4A !important;
        border-color: #F04A4A !important;
    }
    .ant-steps-item-process .ant-steps-icon {
        color: #ffffff !important;
    }
`;

export const EdocGrid = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) 360px;
    gap: 18px;
    align-items: start;

    @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
        grid-template-columns: 1fr;
    }
`;

export const EdocSectionCard = styled.div`
    border-radius: 14px;
    border: 1px solid ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.08)';
    }};
    background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? 'rgba(255,255,255,0.03)' : 'rgba(15, 23, 42, 0.02)';
    }};
    padding: 16px;
    color: var(--ant-color-text);
`;

export const EdocSectionTitle = styled.div`
    font-family: var(--font-family-lufga);
    font-weight: 700;
    font-size: 14px;
    letter-spacing: 0.02em;
    color: var(--ant-color-text-heading);
    margin-bottom: 12px;
`;

export const EdocFieldsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;

    @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
        grid-template-columns: 1fr;
    }
`;

export const EdocSummaryStack = styled.div`
    display: grid;
    gap: 12px;
`;